import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  .closeRow {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    button {
      .closeIcon {
        color: ${({ theme }) => theme.font_secondary};
        font-size: 1.75rem;
      }
    }
  }

  .titleRow {
    font-size: 1.25rem;
    text-align: center;
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.font_secondary};
  }

  .iconRow {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .textRow {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    margin-bottom: 1.5rem;

    .paragraph {
      font-size: 1rem;
      font-weight: 500;
      color: ${({ theme }) => theme.font_primary};
      text-align: center;
    }
  }

  .actionArea {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18rem;

    div {
      button {
        border-radius: 0.5rem;
      }
    }
  }
`;
